import {
    Home,
    BarChart3,
    Users,
    Briefcase,
    Tags,
    Handshake,
    MapPin,
    MessageSquare,
    Megaphone,
    UserCircle,
    Bell,
    Mail,
    Database,
    FlaskConical,
    FileJson,
} from 'lucide-react';

export const ADMIN_NAV_GROUPS = [
    {
        id: 'overview',
        label: 'Resumen',
        items: [
            { key: 'inicio', label: 'Inicio', icon: Home },
            { key: 'estadisticas', label: 'Estadísticas', icon: BarChart3 },
        ],
    },
    {
        id: 'catalog',
        label: 'Catálogo',
        items: [
            { key: 'proveedores', label: 'Proveedores', icon: Briefcase },
            { key: 'categorias', label: 'Categorías', icon: Tags },
            { key: 'partnerships', label: 'Partnerships', icon: Handshake },
            { key: 'locations', label: 'Locations', icon: MapPin },
        ],
    },
    {
        id: 'community',
        label: 'Comunidad',
        items: [
            { key: 'usuarios', label: 'Usuarios', icon: UserCircle },
            { key: 'posts', label: 'Posts', icon: Megaphone },
            { key: 'sugerencias', label: 'Sugerencias', icon: MessageSquare },
        ],
    },
    {
        id: 'comms',
        label: 'Comunicación',
        items: [
            { key: 'notificaciones', label: 'Notificaciones', icon: Bell },
            { key: 'emails', label: 'Emails', icon: Mail },
        ],
    },
    {
        id: 'system',
        label: 'Sistema',
        muted: true,
        items: [
            { key: 'migration', label: 'Migración', icon: Database },
            { key: 'api-tester', label: 'API Tester', icon: FlaskConical },
            { key: 'files', label: 'Archivos JSON', icon: FileJson },
        ],
    },
];

export const ADMIN_NAV_INDEX = ADMIN_NAV_GROUPS.reduce((acc, group) => {
    group.items.forEach((item) => {
        acc[item.key] = { ...item, groupLabel: group.label };
    });
    return acc;
}, {});

export const getNavItem = (key) => ADMIN_NAV_INDEX[key];

export const isValidSection = (key) => Boolean(ADMIN_NAV_INDEX[key]);

export default ADMIN_NAV_GROUPS;
